import React from 'react';
import styled from 'styled-components';
import { IconArrowRight, ButtonTertiary, Text, cssSpacing, screenMdMin, } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext } from '../../ui';
import { Media } from '../../ui/Components/Media';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const Segment = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
`;
const MediaWrapper = styled.div `
  width: 100%;
  @media (max-width: ${screenMdMin}) {
    width: 60%;
    align-self: center;
  }
`;
const Headline = withAnimationContext(styled(Text).attrs({
    variant: 'titleMedium',
    paddingBottom: '0.75em',
}) `
  ${fadeInAnimation(DELAYS.THIRD)};
  padding-top: ${cssSpacing('base')};
  padding-bottom: ${cssSpacing('base')};
  position: relative;
  z-index: 1;

  @media (max-width: ${screenMdMin}) {
    padding-top: ${cssSpacing('base')};
  }
`);
const SegmentTextLink = styled(ButtonTertiary) `
  text-align: center;

  &:hover:not(:focus):not(:disabled) {
    transform: none;
  }
`;
const BodySection = withAnimationContext(styled(Text).attrs({
    variant: 'bodyMedium',
    forwardedAs: 'p',
}) `
  ${fadeInAnimation(DELAYS.FOURTH)};
  position: relative;
  z-index: 1;
`);
const TRACK_CAT = 'module-featuredContent3Up';
export const ThreeUpSegment = ({ threeUpSegment = {}, }) => {
    const { InteractiveElement } = useFrodorModules();
    return (React.createElement(Segment, null,
        React.createElement(MediaWrapper, null,
            React.createElement(Media, { media: threeUpSegment.media })),
        React.createElement(Headline, null, threeUpSegment.headline),
        React.createElement(BodySection, null, threeUpSegment.body),
        threeUpSegment.linkText && threeUpSegment.linkUrl && (React.createElement(InteractiveElement, { customComponent: SegmentTextLink, href: threeUpSegment.linkUrl, trackingCategory: TRACK_CAT, trackingLabel: `Link - ${threeUpSegment.linkText}`, iconTrailing: () => React.createElement(IconArrowRight, { iconSize: 16 }), condensed: true, buttonSize: "sm" }, threeUpSegment.linkText))));
};
